import { CouponNumberGroupConfig } from '@/config/game';
import { CouponState } from '@/reducers/coupon';

export function calculateCouponProgress(
  groupConfig: CouponNumberGroupConfig[],
  crossedNumbers: CouponState
): number {
  const res = groupConfig.reduce(
    (result, group, i) => {
      if (crossedNumbers) {
        result.crossed += crossedNumbers[i].length;
      }
      result.max += group.minCrossed;
      return result;
    },
    {
      crossed: 0,
      max: 0,
    }
  );

  return Math.min(res.crossed / res.max, 1) * 100;
}
